import { render, staticRenderFns } from "./ExpiredContent.vue?vue&type=template&id=26035546&lang=pug&"
import script from "./ExpiredContent.vue?vue&type=script&lang=js&"
export * from "./ExpiredContent.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports